module.exports = __webpack_public_path__ + "static/img/图层46.bd3e8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层46.png
// module id = tpl6
// module chunks = 0